
export default {
    Null : "null",
    Ready : "ready",
    Loading : "loading",
    Error : "error"
}
